import { isNil } from 'ramda'

import type { AtomEffect } from 'recoil'

const localStorageEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet, trigger }) => {
    const { localStorage } = window

    // If there's a persisted value - set it on load
    const loadPersisted = async () => {
      const value = localStorage.getItem(key)

      if (!isNil(value)) {
        setSelf(JSON.parse(value))
      }
    }

    // Asynchronously set the persisted data
    if (trigger === 'get') {
      loadPersisted()
    }

    // Subscribe to state changes and persist them to localForage
    onSet((newValue, _, isReset: boolean) => {
      if (isReset) {
        localStorage.removeItem(key)
      } else {
        localStorage.setItem(key, JSON.stringify(newValue))
      }
    })
  }

export { localStorageEffect }
